export default __webpack_public_path__ + "706e051fb011c8d32f727dfc021fad77.jpg";